import { files, featuredListingsRef } from "@/fireinit.js";
import axios from "axios";
import Vue from "vue";

export default {
  loadAll: async ({ commit, rootState }) => {
    const response = await axios.get(
      `${rootState.axios.API}featuredListing/all`
    );
    let featuredListingList = [];
    response.data.forEach((listing) => {
      featuredListingList.push({ ...listing });
    });
    commit("setFeaturedList", featuredListingList);
  },
  delete: async ({ commit, rootState, dispatch }, ID) => {
    let updateFeaturedListing = await axios.post(
      `${rootState.axios.API}featuredListing/delete`,
      {
        id: ID,
      },
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    dispatch("loadAll");
  },
  save: async ({ commit, rootState, dispatch }, featuredListing) => {
    if (featuredListing.id) {
      let image = null;
      if (featuredListing.image) {
        image = featuredListing.image;
        delete featuredListing.image;
      }
      let mobileImage = null;
      if (featuredListing.mobileImage) {
        mobileImage = featuredListing.mobileImage;
        delete featuredListing.mobileImage;
      }

      if (image) {
        let file = image.file;
        const metadata = {
          contentType: file.type,
        };
        let imageFile = await files
          .child("featuredListingImages/" + featuredListing.id)
          .put(file, metadata);
        let downloadUrl = await imageFile.ref.getDownloadURL();
        featuredListing.imageUrl = downloadUrl;
      }
      if (mobileImage) {
        let file = mobileImage.file;
        const metadata = {
          contentType: file.type,
        };
        let mobileImageFile = await files
          .child("featuredListingImages/mobile_" + featuredListing.id)
          .put(file, metadata);
        let downloadUrl = await mobileImageFile.ref.getDownloadURL();
        featuredListing.mobileImageUrl = downloadUrl;
      }

      featuredListing.firebase_id = null;
      let updateFeaturedListing = await axios.post(
        `${rootState.axios.API}featuredListing/update`,
        featuredListing,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      Vue.notify({
        type: "success",
        duration: 3000,
        title: "Save Successful",
        text: "Featured Listing has successfully been saved",
      });

      return featuredListing;
    } else {
      let createFeaturedListing = await axios.post(
        `${rootState.axios.API}featuredListing/create`,
        featuredListing,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      Vue.notify({
        type: "success",
        duration: 3000,
        title: "Creation Successful",
        text: "Featured Listing has successfully been created",
      });
      let featuredListing_id = createFeaturedListing.data.featuredListingID;
      let response = await axios.get(
        `${rootState.axios.API}featuredListing/${featuredListing_id}`,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      featuredListing = response.data;
      dispatch("loadAllAdmin");
      return { ...featuredListing };
    }
  },
};
